Postlogin = (function (self) {
    self.CareerJournals = {};
    const me = self.CareerJournals;

    me.$userCareerJournalsTable = $('#user-career-journals-table');

    me.initBootstrapTable = function () {
        const userId = me.$userCareerJournalsTable.attr('data-user-id');
        const currentUserId = me.$userCareerJournalsTable.attr('data-current-user-id');
        const userFirstName = me.$userCareerJournalsTable.attr('data-user-first-name');

        me.$userCareerJournalsTable.bootstrapTable({
            formatNoMatches() {
                if (userId === currentUserId) {
                    return 'You have not yet started any Career Journals!';
                }

                return `${userFirstName} has not yet started any Career Journals.`;
            },
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'career_id',
            minimumCountColumns: '2',
            pagination: true,
            search: true,
            sortOrder: 'desc',
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            searchAlign: 'left',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: userId === currentUserId ? '/my-profile/career-journals/json/' : `/users/${userId}/career-journals/json/`,
            pageSize: 25,
            queryParamsType: 'other',
            queryParams(params) {
                const myParams = {};
                myParams.search_term = params.searchText;
                myParams.page = params.pageNumber;
                myParams.page_size = params.pageSize;
                myParams.order_by = params.sortName;
                myParams.sort_order = params.sortOrder;

                return myParams;
            },
            columns: [
                {
                    title: '',
                    field: 'cluster_icon',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: 'Cluster',
                    field: 'cluster_name',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Career',
                    field: 'career_name',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: 'Interest',
                    field: 'interest',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Last Modified',
                    field: 'date_modified',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'PDF',
                    field: 'pdf',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                formattedResult.rows.map((result) => {
                    let row = result;
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    row = Jr.Utils.convertRowDate(row, 'l', ['date_modified']);

                    const clusterViewUrl = me.$userCareerJournalsTable
                        .attr('data-cluster-view-url')
                        .replace(':vjs_section_id', row.vjs_section_id);
                    const careerViewUrl = me.$userCareerJournalsTable
                        .attr('data-career-view-url')
                        .replace(':vjs_section_id', row.vjs_section_id)
                        .replace(':career_id', row.career_id);

                    if (row.cluster_icon) {
                        row.cluster_icon = `<a href="${clusterViewUrl}"><img src="${row.cluster_icon}" style="width: 50px;"/></a>`;
                    } else if (row.cluster_image) {
                        row.cluster_icon = `<a href="${clusterViewUrl}"><img src="${row.cluster_image}" style="width: 50px;"/></a>`;
                    }
                    row.cluster_name = `<a href="${clusterViewUrl}">${row.cluster_name}</a>`;
                    row.career_name = `<a href="${careerViewUrl}">${row.career_name}</a>`;

                    let journalViewUrl;
                    if (userId === currentUserId) {
                        journalViewUrl = me.$userCareerJournalsTable.attr('data-my-journal-view-url').replace(':career_id', row.career_id);
                    } else {
                        journalViewUrl = me.$userCareerJournalsTable
                            .attr('data-journal-view-url')
                            .replace(':user_id', row.user_id)
                            .replace(':career_id', row.career_id);
                    }

                    row.pdf = `<a href="${journalViewUrl}" target="_blank"><i class="fa-regular fa-file-pdf" aria-hidden="true"></i></a>`;
                    return row;
                });

                return formattedResult;
            },
        });
    };

    me.init = function () {
        me.initBootstrapTable();
    };

    return self;
}(Postlogin || {}));
